import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerTalhoes = styled(motion.div)`
    width: 33%;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;
    position: relative;
    overflow: hidden;

    p.Talhoes__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }

    div.Talhoes__list {
        width: 100%;
        height: calc(100% - 65px);
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        padding-right: 15px;
        margin-top: 5px;

        button.Talhoes__list__item {
            width: 100%;
            height: 40px;
            text-align: left;
            border-radius: 5px;
            border: none;
            background: transparent;
            transition: background 0.3s;
            cursor: pointer;

            :hover {
                /* background: rgba(139, 208, 107, 0.1); */
                border: thin solid var(--border-color);
            }

            :disabled {
                cursor: not-allowed;

                :hover {
                    border: none;
                }
            }

            span.Talhoes__list__item__name {
                font-weight: 500;
                font-size: 12px;
                text-transform: capitalize;
                display: flex;
                line-height: 15px;
                padding-bottom: 3px;
            }

            div.Talhoes__list__item__bar {
                margin-top: -8px;
                width: 100%;
                display: flex;
                align-items: center;
                gap: 5px;
                font-size: 11px;
                font-weight: 600;
                color: var(--text-color);

                div.Talhoes__list__item__bar__track {
                    width: 100%;
                    height: 7px;
                    border-radius: 5px;
                    background: #FAFAFA;
                    overflow: hidden;

                    div.Talhoes__list__item__bar__track__progress {
                        width: 0%;
                        height: 100%;
                        border-radius: 5px;
                        background: linear-gradient(to right, #5da57d, #7ebd61);

                        :is([data-overlap = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700);
                        }
                        :is([data-overlap_150 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700, #ffd700);
                        }
                        :is([data-overlap_200 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700, #ffd700, #f14f46);
                        }
                        :is([data-overlap_250 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #7ebd61, #ffd700, #ffd700, #f14f46, #f14f46);
                        }
                        :is([data-overlap_300 = true]) {
                            background: linear-gradient(to right, #5da57d, #7ebd61, #ffd700, #ffd700, #f14f46, #f14f46);
                        }
                    }
                }
            }
        }
    }
`;